<div class="inner">
	<div class="layer-title">
		<h3 class="text-center" style="font-size: 1.5rem;">{{data.title}}</h3>
	</div>
	<p [innerHTML]="data.description"></p>
</div>
<div class="btn_area only">
	<a class="btn btn_type1 btn_layerclose" (click)="onConfirm()">{{data.button}}</a>
</div>
